// =============================================================================
// DATA / DRESSES.JS — Wedding dress boutiques (Calgary)
// Format: { name, email, ig, igLink, url, link }
// To add a boutique: add a new object to the array below.
// =============================================================================

export const dressData = [
  {
    name: "Blush & Raven",
    email: "customerservice@blushandraven.com",
    ig: "@blushandravenyyc",
    igLink: "https://www.instagram.com/blushandravenyyc",
    url: "blushandraven.com",
    link: "https://www.blushandraven.com",
  },
  {
    name: "The Bridal Boutique",
    email: "helloyyc@thebridalboutique.ca",
    ig: "@thebridalboutiqueyyc",
    igLink: "https://www.instagram.com/thebridalboutiqueyyc",
    url: "thebridalboutique.ca",
    link: "https://www.thebridalboutique.ca",
  },
  {
    name: "LOVENOTE",
    email: "calgary@lovenotebride.com",
    ig: "@lovenotebride",
    igLink: "https://www.instagram.com/lovenotebride",
    url: "lovenotebride.com",
    link: "https://lovenotebride.com",
  },
  {
    name: "The Bridal Centre",
    email: "info@bridalcentre.com",
    ig: "@thebridalcentre",
    igLink: "https://www.instagram.com/thebridalcentre",
    url: "bridalcentre.com",
    link: "https://bridalcentre.com",
  },
];
